import React, {useState,useEffect,useRef} from 'react'
import { Formik, Field } from 'formik'
import { Table,Button,Icon,Form,Select,Input,List,Image,Label,TextArea,Message } from 'semantic-ui-react'
import moment from 'moment'
import DatePicker from "react-datepicker"
import Cleave from 'cleave.js/react'
import Paginations from '../../../config/pagination'
import EntryList from '../../../config/entries'
import {WindowReload, WindowURLClient, WindowLocationClient} from '../../../config/settings'
import Alertmessage from '../../../config/alert'
import axios from 'axios'
import renderHTML from 'react-render-html'
import {insertvalidations} from './validate'


export default function TradingBuyComponent(props) {

	const [alert,setalert] = useState(false);
	const [Alertcontent,setAlertcontent] = useState({});
	function Alertclose(){setalert(false);}
	function Alertconfirm(data){if(data.confirm==true){setalert(false);}}
	function Alertdelete(data){
		if(data.delete==true){
		}
	}


	/* ------------------------------------------
		List with paginations
	---------------------------------------------*/
	const [search, setsearch]  = useState({
			account:'',
	});

	const [list, setlist] = useState([]);
	const [pagenumber, setpagenumber] = useState(1);
	const [totaldata, settotaldata] = useState(0);
	const [entry, setentry] = useState(0);
	const [entrytype, setentrytype] = useState('');

	const [paginations, setpaginations] = useState({
			paginations:[{
			listnav:[],
			pageinfo:'',
			limit_page:'',
			total_page:'',
			total_records:'',
			current_page:'',
			startPage:'',
			endPage:'',
			ellipseLeft:'',
			ellipseRight:'',
			}]
	});

	function pagenumberfunction(page){
				TableList(page,search);
		}
		function listreload(){
				TableList(pagenumber,search);
		}
		function searchProcess(){
			  TableList(pagenumber,search);
		}
		function TableList(page,searchstr){

			 setAlertcontent({intent:'inline_spinner',settings:{centered:true,icon:'spinner',title:'Loading',html:"This won't take long, please wait...",footer:'none'}});
			 setalert(true);

				let formData = new FormData();
				formData.append('type','list');
				formData.append('search',JSON.stringify(searchstr));
				formData.append('page',page);
				axios.post('/client/tradingbuy/http.php',formData)
				.then(function (response) {
						let obj = response.data;
						setentry(obj.entries.val);
						setentrytype(obj.entries.type);
						setlist(obj.listtable);
						setpaginations(obj.paginations);
						settotaldata(obj.paginations.paginations.total_records);
						setalert(false);

				})
				.catch(function (error){
					setAlertcontent({intent:'alert',settings:{centered:false,icon:'warning',title:'Server Error!',html:"Problem connecting to the server. Contact the administrator.",footer:'yes'}});
					setalert(false);
				});
		}

		function handleSubmitForm(values, props){
			TableList(pagenumber,values);
	  }

	 /* ------------------------------------------
			List with paginations end
		---------------------------------------------*/




	useEffect(()=>{
		TableList(pagenumber,search);
	},[]);


	return (
		<React.Fragment>
      <div className="page-wrapper">
				{alert&&<Alertmessage close={Alertclose} data={Alertcontent} confirm={Alertconfirm} delete={Alertdelete}/>}

					<div className="panel">
						 <div className="panel-header">Trading Record-Buy</div>
						 <div className="panel-body">
						 	 <div className="table-responsive">
								 <Table celled singleLine unstackable>
									 <Table.Header>
										 <Table.Row>
											 <Table.HeaderCell>Trade Date</Table.HeaderCell>
											 <Table.HeaderCell>Trade Time</Table.HeaderCell>
											 <Table.HeaderCell>Trade Ref.No.</Table.HeaderCell>
											 <Table.HeaderCell>Subscription</Table.HeaderCell>
											 <Table.HeaderCell>Index</Table.HeaderCell>
											 <Table.HeaderCell>Class</Table.HeaderCell>
											 <Table.HeaderCell>Cusip No.</Table.HeaderCell>
											 <Table.HeaderCell>Quantity</Table.HeaderCell>
											 <Table.HeaderCell>Bid Price</Table.HeaderCell>
											 <Table.HeaderCell>Price Per Share</Table.HeaderCell>
											 <Table.HeaderCell>Trade Amount</Table.HeaderCell>
											 <Table.HeaderCell>Trade Fees</Table.HeaderCell>
											 <Table.HeaderCell>Trade Total</Table.HeaderCell>
											 <Table.HeaderCell>Status</Table.HeaderCell>
										 </Table.Row>
									 </Table.Header>

									 <Table.Body>
												 {list.length==0&&<Table.Row negative><Table.Cell  colSpan='14' textAlign="center">No record found</Table.Cell></Table.Row>}
												 {list.map(function(data, key){
													 return <Table.Row key={key}>
															 <Table.Cell>{data.trade_date}</Table.Cell>
															 <Table.Cell>{data.trade_time}</Table.Cell>
															 <Table.Cell>{data.trade_refnumber}</Table.Cell>
															 <Table.Cell>{data.subscription}</Table.Cell>
															 <Table.Cell>{data.trade_index}</Table.Cell>
															 <Table.Cell>{data.trade_class}</Table.Cell>
															 <Table.Cell>{data.cusip_no}</Table.Cell>
															 <Table.Cell>{data.quantity}</Table.Cell>
															 <Table.Cell>{data.bid_price}</Table.Cell>
															 <Table.Cell>{data.strike_price}</Table.Cell>
															 <Table.Cell>{data.trade_amount}</Table.Cell>
															 <Table.Cell>{data.trade_fees}</Table.Cell>
															 <Table.Cell>{data.trade_total}</Table.Cell>
															 <Table.Cell>{data.status}</Table.Cell>
													 </Table.Row>
												 })}
										 </Table.Body>
										 {list.length>0&&
											 <Table.Footer fullWidth>
													 <Table.Row>
													 <Table.HeaderCell colSpan='14'>
															 <div className="dash-footer"><Paginations callbackPagination={paginations} callbackPagenumber={pagenumberfunction}/></div>
													 </Table.HeaderCell>
													 </Table.Row>
											 </Table.Footer>
										 }
								 </Table>
								 </div>

								 <Message
								  negative
							    icon='info circle'
							    header='Legend'
							    content='H-shares are regulated by Chinese law but are denominated in Hong Kong Dollars.'
							  />

						 </div>
					</div>

      </div>
    </React.Fragment>
  )
}
